(function(){
     'use strict';

     angular
        .module('app')
        .factory('RegistroService', RegistroService);

    RegistroService.$inject = ['$http'];

    function RegistroService($http){

        var service= {
           RegistroForm:RegistroForm,

        };

         function RegistroForm(vm){
            var config = {
                headers : {
                   // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            
            return $http.post('/ajax/registro', {
             
                //cobro:vm.cobro,
                //iban:vm.iban,
                acepto_datoscontrato:vm.acepto_datoscontrato,
                acepto_enviocom:vm.acepto_enviocom,
                acepto_enviocomesp:vm.acepto_enviocomesp,
                acepto_imagen:vm.acepto_imagen,
                datos_contrato:vm.datos_contrato,
                //condiciones:vm.condiciones,
                //especie:vm.especie,
                colegiado:vm.colegiado,
                user_id:vm.user_id,
                firma:vm.signature,
                // validado:vm.validado

             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };




        return service;

    }

})();